import "./listPage.scss";

import Filter from "../../components/filter/Filter";
import Card from "../../components/cards/card/Card";
import Map from "../../components/map/Map";

// import { useLoaderData } from "react-router-dom";
import { useLocation,useNavigate } from "react-router-dom";

import { useState, useEffect,useRef,useMemo } from "react";
import CurvedMenuToggle from "../../components/curvedToggleMenu/CurvedMenuToggle";
import usePaginatedList from "../../components/paginationlist/usePaginationList";
import ContainerLoader from "../../components/spinner/ContainerLoader";
import OverlayLoader from "../../components/spinner/OverlayLoader";
import SliderComponent from "../../components/basicslider/ImageSlider";

import space1 from "../../assets/ads/space/banner/1.png";
import space2 from "../../assets/ads/space/banner/2.png";
import space3 from "../../assets/ads/space/banner/3.png";
import space4 from "../../assets/ads/space/banner/4.png";
import spacevideo from "../../assets/ads/space/banner/spacehomebanner.mp4";

import PropertyTypeSlider from "../../components/basicslider/PropertyTypeSlider";
import { consumeObjectDraft } from "../../lib/objectReturnStore";


function ListPage() {

  // default	        First load, no restored state, no navigation filters
  // restored	        Page comes back from detail view, state exists 
  // filterChanged	  User applies a filter manually or comes via navigation with filters
  // pageChanged	    User scrolls / paginates

    const location=useLocation();
    const pageLimit=10;
    const filterRef=useRef(null);
  

useEffect(() => {
  if (location.state) {
    // console.log("Filter changed:", location.state);
    applyNavFilters(location.state)
    // apply filter
  }
}, [location.state]);




// ✅ Load filters from location state or fallback to default
    const defaultFilters = {
        transtype: 0,
        propertytype: [],
        colonies: [],
        tags: [],
        maxprice: 0,
        minprice: 0,
        bedroom: 0,
    };


// Merge location.state if user navigated with filters
  const navFilters = location.state
    ? { ...defaultFilters, ...location.state }
    : null;

// console.log("navFilters: ",navFilters);


  const storageKey = "propertyListPage"; // unique key for this page
  const shouldRestore = !navFilters; // only means "eligible" to restore



// Initialize hook
const {
    items: posts,
    setItems,
    page,
    applyNavFilters, // the exposed function to apply filters
    loading,
    reloading,
    // setPage,
    hasMore,
    filters,
    // total,
    setFilters,
    // loadNexPage,
    // resetList,
    // setInitialPage,
    // setLoading,
    // setRestoredPage,
    // serverTotal,
    // refresh,
    // hydrateTotalPages,
    // finishHydration,
    //  isFetching, // 👈 now you can use it
} = usePaginatedList("/posts", {
    limit: pageLimit,
    initialFilters: navFilters || defaultFilters,
    scrollContainerSelector: ".cardList",
    storageKey: storageKey,
    skipInitialFetch: false, // skip fetch if restoring posts
    onRestore: (restored) => {
        // console.log("Restoration callback:", restored);

        if (filterRef.current) {
          filterRef.current.showFilter(restored.filters);
        }

        
      },

});



function restoreDraft() {

  const draft = consumeObjectDraft();
  if (!draft) return false;

  // console.log("posts ", posts);

  const returnedPost=draft.returnData;


  switch (draft.action) {

    case 'update':
      // console.log("now updating");

      setItems(prevPosts =>
        prevPosts.map(post => {
          // console.log("Checking post:", post.id, "against draft:", returnedPost.id);
          if (String(post.id) === String(returnedPost.id)) {
            // console.log("Updating post:", post, "with draft:", returnedPost);
            return { ...post, ...returnedPost };
          }
          return post;
        })
      );
      break;

    case 'add':
      // console.log("now adding");

      setItems(prevPosts => [returnedPost, ...prevPosts]);

      break;

    case 'delete':
      // console.log("now deleting");

      setItems(prevPosts =>
        prevPosts.filter(p => p.id !== returnedPost.id)
      );

      break;
  }

  // console.log("restored draft", draft);

  return true;
}



useEffect(() => {
  // to restore if coming back from savepost
  restoreDraft();
}, []);




  
//   const limit = 10; // Adjust to match your backend pagination limit
  const navigate = useNavigate();

  // useEffect(() => {
  //   if (!navFilters) return;

  //   // console.log("🟢 Applying navFilters to Filter UI:", navFilters);

  //   if (filterRef.current) {
  //     filterRef.current.showFilter(navFilters);
  //   }

  // }, [navFilters]);







  // --------------------------
  // 🔹 Mark a post as messaged (local UI update only)
  // --------------------------
  const markPostAsMessaged = (postId) => {

    setItems((prev) =>
      prev.map((post) =>
        post.id === postId ? { ...post, messaged: 1 } : post
      )
    );

  };




  return (
    <div className="listPage">
      {/* MAP SECTION */}
      <div className="mapContainer">
        {/* {console.log("Posts in maps: ", posts)} */}
        {!loading ? (
          posts.length > 0 ? (
            <Map key={posts[0]?.id ?? "empty"} items={posts} />
          ) : (
            <p>No posts found</p>
          )
        ) : (
          // <p>Loading map…</p> // placeholder before hydration
          <ContainerLoader/>
        )}
      </div>

      {/* LIST SECTION */}
      <div className="listContainer">
        <div className="wrapper">

        

          <div className="ListPageAds">
            <PropertyTypeSlider
              PropertyTypes={[{id:'2',propertytype:'DDA Flat'},{id:'',propertytype:'builder floor'}]}
            >

            </PropertyTypeSlider>

          </div>
          
          <div className="FilterContainer">
            <CurvedMenuToggle
              curve="top"
              defaultOpen={false}
              menuColor="#e0e0e0"
              iconColor="#444"
            >
            <div> 
              <Filter 
                ref={filterRef}
                filterOptions={navFilters} 
                // onFilterApply={handleFilterApply} 
                onFilterApply={(newFilters) => {
                  // console.log("Applying new filters:", newFilters);
                  applyNavFilters(newFilters); // ✅ call the hook’s function
                }}
              />

            </div>
            

            </CurvedMenuToggle>

          </div>



          <div className="cardList"  style={{ position: 'relative' }}>

              {/* <div className="listHeader">
              <h2>Properties</h2>
                <p>Total fetched: {posts.length}</p>
              </div> */}



            {/* {console.log("posts",posts)} */}
            {!loading ? (
              posts.length > 0 ? (

                posts.map((post) => (

                  <Card
                    key={post.id}
                    item={post}
                    onMarkMessaged={() => markPostAsMessaged(post.id)}
                    // onNavigateSavePost={handleNavigateSavePost}
                    // onNavigatePostView={handleNavigatePostView}
                  />
                ))
              ):(
                <p>No posts found</p>
              )

            ) : (
              // <p>Loading Posts</p>
              <ContainerLoader/>
            )}


            {reloading && (
                <OverlayLoader 
                  position="sticky"
                  bottom={0}
                  text="Loading more..."
                  background= "rgba(200, 200, 200, 0.7)"
                  height="150px"

                />
              )}
          </div>

        </div>
      </div>
    </div>
  );
}

export default ListPage;
